module.exports = __webpack_public_path__ + "static/media/buttonlink.96290a4a.svg";